export default __webpack_public_path__ + "static/media/logo-full.20abd6c8.png";